// extracted by mini-css-extract-plugin
module.exports = {"navbarHeight":"70px","label":"styles_label__1Prg_","input":"styles_input__HHj-Z"};